var Breakpoints =
/* @__PURE__ */
function (Breakpoints2) {
  Breakpoints2[Breakpoints2["xs"] = 320] = "xs";
  Breakpoints2[Breakpoints2["sm"] = 480] = "sm";
  Breakpoints2[Breakpoints2["ms"] = 600] = "ms";
  Breakpoints2[Breakpoints2["md"] = 768] = "md";
  Breakpoints2[Breakpoints2["ml"] = 960] = "ml";
  Breakpoints2[Breakpoints2["lg"] = 1024] = "lg";
  Breakpoints2[Breakpoints2["xl"] = 1280] = "xl";
  Breakpoints2[Breakpoints2["xxl"] = 1330] = "xxl";
  Breakpoints2[Breakpoints2["jb"] = 1440] = "jb";
  return Breakpoints2;
}(Breakpoints || {});

export { Breakpoints };